export const NAMESPACE = 'GREENMILE';

export const nextAction = type => ({
  success: payload => ({
    type: `${type}_SUCCESS`,
    payload,
  }),
});

export const defaultCrudAction = (
  dispatch, actionType, entity, method = 'GET', url,
) => (
    payload => (
      dispatch({
        entity,
        method,
        url,
        type: actionType,
        payload,
      })
    )
  );

export const defaultAction = (dispatch, actionType) => (
  payload => (
    dispatch({
      type: actionType,
      payload,
    })
  )
);

export const createAlertMessageModalActions = (module, suffix) => {
  const MODULE = module.toUpperCase();
  const SUFFIX = (suffix) ? `_${suffix.toUpperCase()}` : '';
  const actions = {
    OPEN_MODAL: `${NAMESPACE}_${MODULE}_OPEN_ALERT_MESSAGE_MODAL${SUFFIX}`,
    CLOSE_MODAL: `${NAMESPACE}_${MODULE}_CLOSE_ALERT_MESSAGE_MODAL${SUFFIX}`,
    UPDATE_CONTENT: `${NAMESPACE}_${MODULE}_UPDATE_CONTENT_TO_ALERT_MESSAGE_MODAL${SUFFIX}`,
    TOGGLE_CONTENT: `${NAMESPACE}_${MODULE}_TOGGLE_ALERT_MESSAGE_MODAL${SUFFIX}`,
    OPEN_MODAL_AND_UPDATE_CONTENT: `${NAMESPACE}_${MODULE}_OPEN_AND_UPDATE_CONTENT_TO_ALERT_MESSAGE_MODAL${SUFFIX}`
  };
  const actionCreators = {
    openModal: () => ({ type: actions.OPEN_MODAL }),
    closeModal: () => ({ type: actions.CLOSE_MODAL }),
    updateContent: payload => ({ type: actions.UPDATE_CONTENT, payload }),
    toggleContent: () => ({ type: actions.TOGGLE_CONTENT }),
    openModalAndUpdateContent: payload => ({
      type: actions.OPEN_MODAL_AND_UPDATE_CONTENT, payload
    })
  };
  return {
    actions,
    actionCreators
  };
};

export default {
  defaultCrudAction,
  defaultAction,
  NAMESPACE,
};
